import { get, put } from "@readai/common/api";
import type {
  ApiUserIntegrationSetting,
  ApiWorkspaceIntegrationSetting,
  UpdateIntegrationSettingRequestBody,
  UpdateIntegrationSettingValidationError,
  UserIntegrationSetting,
  WorkspaceIntegrationSetting,
} from "@readai/common/types/integrationSettingsTypes";
import type { EnterpriseWorkspace } from "@readai/common/types/workspaceTypes";

import * as IntegrationSettingsParser from "./parsers/integrationSettings";

export const listUserIntegrationSettings = async (): Promise<
  UserIntegrationSetting[]
> => {
  const response: ApiUserIntegrationSetting[] = await get(
    "/users/me/integration-settings",
    { withCreds: true },
  );

  return IntegrationSettingsParser.parseUserIntegrationSettingsResponse(
    response,
  );
};

export const listWorkspaceIntegrationSettings = async (
  workspaceId?: EnterpriseWorkspace["id"],
): Promise<WorkspaceIntegrationSetting[]> => {
  if (!workspaceId) return [];

  const response: ApiWorkspaceIntegrationSetting[] = await get(
    `/enterprise/workspaces/${workspaceId}/integration-settings`,
    { withCreds: true },
  );

  return IntegrationSettingsParser.parseWorkspaceIntegrationSettingsResponse(
    response,
  );
};

export const updateIntegrationSetting = async ({
  integrationKind,
  ...body
}: UpdateIntegrationSettingRequestBody): Promise<
  string | UpdateIntegrationSettingValidationError
> =>
  put(`/users/me/${integrationKind}/integration-settings`, body, {
    withCreds: true,
  });
